var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-langs-group"},_vm._l((_vm.langs),function(lang,i){return _c('the-button',{key:i,attrs:{"link":lang.link,"cssClass":'c-langs-group__button'}},[_vm._v("\n    "+_vm._s(lang.name)+"\n  ")])}))}
var staticRenderFns = []

export { render, staticRenderFns }